import { render } from "./SoustractionDynamique.vue?vue&type=template&id=ed754ab6&scoped=true"
import script from "./SoustractionDynamique.vue?vue&type=script&lang=js"
export * from "./SoustractionDynamique.vue?vue&type=script&lang=js"

import "./SoustractionDynamique.vue?vue&type=style&index=0&id=ed754ab6&scoped=true&lang=css"

import exportComponent from "/Volumes/FITS/Projets-VueJs/montessori-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed754ab6"]])

export default __exports__